module.exports = __webpack_public_path__ + "img/tips.e85a6ac2.png";